(function() {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('StepNode', StepNode);

    StepNode.$inject = ['$resource'];

    function StepNode ($resource) {
        var resourceUrl =  'api/steps-tree';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
